import { language } from './language';

var DEFAULT_ERROR_HANDLE = function DEFAULT_ERROR_HANDLE(error) {
  var response = error.response,
      status = error.status;
  alert(status === undefined ? language.getText('error.requestTerminated') : response && response.body && response.body.err_msg || language.getText('error.requestFailed'));
};

var ERROR_HANDLE = DEFAULT_ERROR_HANDLE;
export function replaceErrorHandle(errorHandle) {
  ERROR_HANDLE = errorHandle;
}
/**
 * 处理接口调用失败的错误信息
 * @param error
 */

export var errorHandle = function errorHandle(error) {
  var errorHandle = ERROR_HANDLE;
  errorHandle(error);
};